// if (!customElements.get('quick-add-modal')) {
//   customElements.define(
//     'quick-add-modal',
//     class QuickAddModal extends ModalDialog {
//       constructor() {
//         super();
//         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
//       }

//       hide(preventFocus = false) {
//         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//         this.modalContent.innerHTML = '';

//         if (preventFocus) this.openedBy = null;
//         super.hide();
//       }

//       show(opener) {
//         opener.setAttribute('aria-disabled', true);
//         opener.classList.add('loading');
//         opener.querySelector('.loading__spinner').classList.remove('hidden');

//         fetch(opener.getAttribute('data-product-url'))
//           .then((response) => response.text())
//           .then((responseText) => {
//             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//             this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
//             this.productElement.classList.forEach((classApplied) => {
//               if (classApplied.startsWith('color-') || classApplied === 'gradient')
//                 this.modalContent.classList.add(classApplied);
//             });
//             this.preventDuplicatedIDs();
//             this.removeDOMElements();
//             this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

//             if (window.Shopify && Shopify.PaymentButton) {
//               Shopify.PaymentButton.init();
//             }

//             if (window.ProductModel) window.ProductModel.loadShopifyXR();

//             this.removeGalleryListSemantic();
//             this.updateImageSizes();
//             this.preventVariantURLSwitching();
//             super.show(opener);
//           })
//           .finally(() => {
//             opener.removeAttribute('aria-disabled');
//             opener.classList.remove('loading');
//             opener.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       setInnerHTML(element, html) {
//         element.innerHTML = html;

//         // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//         element.querySelectorAll('script').forEach((oldScriptTag) => {
//           const newScriptTag = document.createElement('script');
//           Array.from(oldScriptTag.attributes).forEach((attribute) => {
//             newScriptTag.setAttribute(attribute.name, attribute.value);
//           });
//           newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//           oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//         });
//       }

//       preventVariantURLSwitching() {
//         const variantPicker = this.modalContent.querySelector('variant-selects');
//         if (!variantPicker) return;

//         variantPicker.setAttribute('data-update-url', 'false');
//       }

//       removeDOMElements() {
//         const pickupAvailability = this.productElement.querySelector('pickup-availability');
//         if (pickupAvailability) pickupAvailability.remove();

//         const productModal = this.productElement.querySelector('product-modal');
//         if (productModal) productModal.remove();

//         const modalDialog = this.productElement.querySelectorAll('modal-dialog');
//         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
//       }

//       preventDuplicatedIDs() {
//         const sectionId = this.productElement.dataset.section;
//         this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
//         this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
//           element.dataset.originalSection = sectionId;
//         });
//       }

//       removeGalleryListSemantic() {
//         const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
//         if (!galleryList) return;

//         galleryList.setAttribute('role', 'presentation');
//         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
//       }

//       updateImageSizes() {
//         const product = this.modalContent.querySelector('.product');
//         const desktopColumns = product.classList.contains('product--columns');
//         if (!desktopColumns) return;

//         const mediaImages = product.querySelectorAll('.product__media img');
//         if (!mediaImages.length) return;

//         let mediaImageSizes =
//           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

//         if (product.classList.contains('product--medium')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//         } else if (product.classList.contains('product--small')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//         }

//         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
//       }
//     }
//   );
// }


if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Store cart item edit context from opener attributes
        this._cartItemKey = opener.getAttribute('data-cart-item-key') || null;
        this._currentVariantId = opener.getAttribute('data-current-variant-id') || null;
        this._currentQuantity = parseInt(opener.getAttribute('data-current-quantity')) || 1;

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            // Wait for DOM to be fully rendered before applying edit mode
            setTimeout(() => {
              if (this._cartItemKey) {
                this._applyEditMode();
              }
            }, 100);

            super.show(opener);
          })
          .catch((error) => {
            console.error('Error loading product:', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');

            const spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      _applyEditMode() {
        const variantId = this._currentVariantId;
        const quantity = this._currentQuantity;

        // --- 1. Intercept the Add to Cart button ---
        const addToCartBtn = this.modalContent.querySelector('[name="add"], .product-form__submit');
        if (addToCartBtn) {
          const btnSpan = addToCartBtn.querySelector('span:not(.sold-out-message)');
          if (btnSpan) btnSpan.textContent = 'Update Item';
          else addToCartBtn.textContent = 'Update Item';

          // Remove existing listeners and add new one
          const newBtn = addToCartBtn.cloneNode(true);
          addToCartBtn.parentNode.replaceChild(newBtn, addToCartBtn);
          
          newBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this._updateCartItem(newBtn);
          });
        }

        // --- 2. Set quantity first (simpler) ---
        this._setQuantityValue(quantity);

        // --- 3. Handle variant selection without triggering errors ---
        if (variantId) {
          this._setVariantWithoutErrors(variantId);
        }
      }

      _setQuantityValue(quantity) {
        const setQuantity = () => {
          const qtyInput = this.modalContent.querySelector('input[name="quantity"]');
          if (qtyInput) {
            qtyInput.value = quantity;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
          return false;
        };

        if (!setQuantity()) {
          const observer = new MutationObserver(() => {
            if (setQuantity()) observer.disconnect();
          });
          observer.observe(this.modalContent, { childList: true, subtree: true });
          setTimeout(() => observer.disconnect(), 2000);
        }
      }

      _setVariantWithoutErrors(variantId) {
        // Direct approach: find and set the hidden input directly
        const hiddenIdInput = this.modalContent.querySelector('input[name="id"].product-variant-id');
        if (hiddenIdInput) {
          hiddenIdInput.value = variantId;
          hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Also try to update the variant picker UI without triggering errors
        const variantPicker = this.modalContent.querySelector('variant-selects, variant-radios');
        if (variantPicker) {
          // Find the variant data
          const variantData = this._findVariantData();
          const targetVariant = variantData?.find(v => String(v.id) === String(variantId));
          
          if (targetVariant && targetVariant.options) {
            // Update selects without triggering change events
            const selects = variantPicker.querySelectorAll('select');
            selects.forEach((select, index) => {
              if (targetVariant.options[index]) {
                select.value = targetVariant.options[index];
              }
            });
            
            // Update radios without triggering change events
            const radios = variantPicker.querySelectorAll('input[type="radio"]');
            radios.forEach(radio => {
              const optionIndex = parseInt(radio.getAttribute('data-option-index') || '0');
              if (targetVariant.options[optionIndex]) {
                radio.checked = (radio.value === targetVariant.options[optionIndex]);
              }
            });
          }
        }
      }

      _findVariantData() {
        // Look for variant data in script tags
        const scripts = this.modalContent.querySelectorAll('script[type="application/json"]');
        for (const script of scripts) {
          try {
            const parsed = JSON.parse(script.textContent);
            if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].hasOwnProperty('id')) {
              return parsed;
            }
          } catch (e) {}
        }
        return null;
      }

      async _updateCartItem(btn) {
        const cartItemKey = this._cartItemKey;
        
        // Get the current variant ID and quantity from the modal
        const variantInput = this.modalContent.querySelector('input[name="id"].product-variant-id');
        const newVariantId = variantInput ? variantInput.value : this._currentVariantId;
        
        const qtyInput = this.modalContent.querySelector('input[name="quantity"]');
        const newQty = qtyInput ? parseInt(qtyInput.value) : this._currentQuantity;

        if (!newVariantId || !cartItemKey) {
          console.error('Missing variant ID or cart item key');
          return;
        }

        btn.setAttribute('aria-disabled', true);
        btn.classList.add('loading');
        const spinner = btn.querySelector('.loading-overlay__spinner, .loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        try {
          // First, remove the old item
          const removeResponse = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: cartItemKey, quantity: 0 }),
          });

          if (!removeResponse.ok) {
            throw new Error('Failed to remove old item');
          }

          // Then add the updated item
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: newVariantId, quantity: newQty }),
          });

          if (!addResponse.ok) {
            throw new Error('Failed to add updated item');
          }

          // Refresh the cart drawer
          await this._refreshCartDrawer();
          
          // Close the modal
          this.hide();
          
          // Dispatch event to notify cart update
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
        } catch (err) {
          console.error('Update failed:', err);
          // Show error to user
          const errorElement = document.getElementById('CartDrawer-CartErrors');
          if (errorElement) {
            errorElement.textContent = 'Failed to update item. Please try again.';
            errorElement.style.display = 'block';
            setTimeout(() => {
              errorElement.style.display = 'none';
            }, 3000);
          }
        } finally {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      async _refreshCartDrawer() {
        const sections = ['cart-drawer', 'cart-icon-bubble'];
        const sectionIds = sections.join(',');
        
        try {
          const response = await fetch(`${window.Shopify.routes.root}?sections=${sectionIds}`);
          const data = await response.json();
          
          // Update cart drawer if it exists
          if (data['cart-drawer']) {
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
            const newDrawerInner = newDoc.querySelector('.drawer__inner');
            const currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');
            
            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }
          }
          
          // Update cart count in icon bubble
          if (data['cart-icon-bubble']) {
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
            const newCartCount = newDoc.querySelector('.cart-count-bubble');
            const currentCartCount = document.querySelector('.cart-count-bubble');
            
            if (newCartCount && currentCartCount) {
              currentCartCount.innerHTML = newCartCount.innerHTML;
            }
          }
        } catch (error) {
          console.error('Failed to refresh cart:', error);
          window.location.reload();
        }
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}